import type { MissionAssessmentInterAiGenerationDataDto } from '@@types/api.types';
import { FieldedStatus, MissionAssessmentInterType, VerificationConfidence } from '@@types/api.types';
import { asOptionalNumber, asOptionalString, asStringArray, isEnumValue } from '@utils/parse.util';

/**
 * Parse a server-validated chat artifact object into the interoperability
 * generation shape. Lenient like the inline accept handler: missing strings
 * default to empty, and the section's relationship type wins when absent.
 */
export const parseGeneratedInterData = (
  value: Record<string, unknown>,
  fallbackType: MissionAssessmentInterType,
): MissionAssessmentInterAiGenerationDataDto => {
  return {
    categoryId: asOptionalString(value.categoryId) ?? '',
    description: asOptionalString(value.description) ?? '',
    digitalIntegrationIds: asStringArray(value.digitalIntegrationIds),
    fieldedStatus: isEnumValue(FieldedStatus, value.fieldedStatus) ? value.fieldedStatus : undefined,
    mrl: asOptionalNumber(value.mrl),
    name: asOptionalString(value.name) ?? '',
    notes: asOptionalString(value.notes) ?? '',
    operationalIntegrationIds: asStringArray(value.operationalIntegrationIds),
    physicalIntegrationIds: asStringArray(value.physicalIntegrationIds),
    priorityRationale: asOptionalString(value.priorityRationale),
    priorityScore: asOptionalNumber(value.priorityScore),
    reference: asOptionalString(value.reference),
    subcategoryId: asOptionalString(value.subcategoryId) ?? '',
    trl: asOptionalNumber(value.trl),
    type: isEnumValue(MissionAssessmentInterType, value.type) ? value.type : fallbackType,
    verificationConfidence: isEnumValue(VerificationConfidence, value.verificationConfidence)
      ? value.verificationConfidence
      : undefined,
    verificationNotes: asOptionalString(value.verificationNotes),
  };
};
